import { useCallback, useContext, useEffect, useState } from 'react'

import { Tabs, Text } from '@hhgtech/hhg-components'
import { useIsMobile } from 'hooks/useIsMobile'
import { useIntl } from 'react-intl'
import { AppContext } from 'state/appContext'

import { CardPostWithCommentData } from '../cardPost'
import { TogetherDataContext } from '../common/TogetherDataWrapper'
import { formatPost } from '../common/TogetherDataWrapper/api/dataTransform'
import { getPostListsByArticleId } from '../common/TogetherDataWrapper/api/services'
import { useInfinityScrollPost } from '../common/TogetherDataWrapper/hooks/useInfinityScrollPost'
import { PostActions } from '../common/TogetherDataWrapper/state/postReducer'
import { AskDoctorContext } from '../context'
import { InputPost } from '../inputPost'
import { Post } from '../interfaces/types'
import { NotiScreen } from '../notiScreen'
import { PostDetail } from '../postDetail'
import { PostForm } from '../postForm'
import { Section } from '../Section'
import {
  StyledLink,
  StyledListWrapper,
  StyledLoading,
  StyledLoginReminder,
  StyledTabWrapper,
} from './index.styled'

const MainBody = ({ postCount = 0 }: { postCount: number }) => {
  const { formatMessage: f } = useIntl()
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)

  const { dispatch } = useContext(TogetherDataContext)
  const isMobile = useIsMobile()
  const {
    article,
    showPostDetailPopup,
    setShowPostDetailPopup,
    setSelectedPost,
    showPostForm,
    setShowPostForm,
    handleClosePopup,
    handleRedirectSSO,
    setEditPostData,
    setPostCount,
    selectedPost,
  } = useContext(AskDoctorContext)
  const articleId = String(article?.id)

  const {
    posts,
    setPosts,
    postContainerRef,
    handleCreateEditPost,
    handleDeletePost,
    refetch,
  } = useInfinityScrollPost({
    requestParams: {
      articleId: article?.id,
    },
  })
  const [loadingData, setLoadingData] = useState(false)
  const [activeTabs, setActiveTabs] = useState<number>(0)
  const tabsProps = {
    initialTab: 0,
    tabContent: [
      {
        name: f({
          id: 'askDoctor.postList.allTab.heading',
          defaultMessage: 'Tất cả thảo luận',
        }),
      },
      {
        name: f({
          id: 'askDoctor.postList.popularTab.heading',
          defaultMessage: 'Nổi bật',
        }),
      },
    ],
    onChange: (n: number) => setActiveTabs(n),
  }

  const fetchPosts = useCallback(
    async (id: string, sortBy = 'newest', isLoggedIn = false) => {
      setLoadingData(true)
      try {
        const res = await getPostListsByArticleId(id, sortBy, isLoggedIn)
        const data = (res?.data?.posts || []).map(formatPost)
        setPosts(data)
        setPostCount(data.length)
        setLoadingData(false)
        dispatch({
          type: PostActions.updateMultiple,
          payload: {
            dataArr: data,
          },
        })
      } catch {}
    },
    [isLoggedIn],
  )

  useEffect(() => {
    fetchPosts(
      articleId,
      activeTabs === 0 ? 'newest' : 'popularity',
      isLoggedIn,
    )
  }, [activeTabs])

  // useEffect(() => {
  //   !loading && setPostCount?.(posts.length)
  // }, [posts])

  useEffect(() => {
    selectedPost &&
      dispatch({
        type: PostActions.update,
        payload: {
          data: selectedPost,
        },
      })
  }, [selectedPost])

  return (
    <>
      <Section
        heading={f({
          id: 'askDoctor.heading',
          defaultMessage: 'Đặt câu hỏi cho bác sĩ',
        })}
        handleCloseFn={handleClosePopup}
        footer={
          <>
            <InputPost
              onClick={() =>
                isLoggedIn
                  ? setShowPostForm(!showPostForm)
                  : handleRedirectSSO?.()
              }
            />
            {!isLoggedIn && (
              <StyledLoginReminder>
                <Text size="p2" color={'#202135'}>
                  {f(
                    {
                      id: 'askDoctor.heading',
                      defaultMessage:
                        '{register} hoặc {login} để đặt câu hỏi cho bác sĩ!',
                    },
                    {
                      register: (
                        <StyledLink
                          href="#"
                          onClick={(e) => {
                            e.preventDefault()
                            handleRedirectSSO?.()
                          }}
                        >
                          Đăng ký
                        </StyledLink>
                      ),
                      login: (
                        <StyledLink
                          href="#"
                          onClick={(e) => {
                            e.preventDefault()
                            handleRedirectSSO?.()
                          }}
                        >
                          Đăng nhập
                        </StyledLink>
                      ),
                    },
                  )}
                </Text>
              </StyledLoginReminder>
            )}
          </>
        }
      >
        <StyledListWrapper
          ref={postContainerRef}
          data-has-message={posts.length === 0 && !loadingData}
        >
          {postCount > 0 && (
            <StyledTabWrapper>
              <Tabs {...tabsProps} />
            </StyledTabWrapper>
          )}

          {loadingData ? (
            <StyledLoading />
          ) : postCount > 0 ? (
            posts.map((post: any) => {
              // const post = postsById[key]
              return (
                <CardPostWithCommentData
                  key={post?.id}
                  isMobile={isMobile}
                  title={post.title}
                  id={post.id}
                  slug={post.slug}
                  community={post.community}
                  author={post.author}
                  postDate={post.createdDate}
                  topics={post.topics}
                  photos={post.photos}
                  previewUrl={post.previewUrl}
                  description={post.description}
                  commentCount={post.commentCount}
                  loveCount={post.likeCount}
                  isLiked={post.isLiked}
                  post={post}
                  hasLinkWrapper
                  onDeletePost={() => {
                    handleDeletePost?.(String(post?.id))
                    setPostCount((v: number) => v - 1)
                  }}
                  onEditPost={() => {
                    setShowPostForm(true)
                    setEditPostData(post)
                  }}
                  returnUrl={article?.permalink}
                  onPostCommentSuccess={() => {
                    setShowPostDetailPopup?.(true)
                    setSelectedPost?.(post)
                    refetch?.()
                  }}
                  onViewMoreCommentClick={(post) => {
                    setShowPostDetailPopup?.(true)
                    setSelectedPost?.(post)
                  }}
                  onDisplayCommentClick={() => {
                    setShowPostDetailPopup?.(true)
                    setSelectedPost?.(post)
                  }}
                  handleRedirectSSO={handleRedirectSSO}
                />
              )
            })
          ) : isLoggedIn ? (
            <NotiScreen
              heading={f({
                id: 'askDoctor.welcome.heading',
                defaultMessage: 'Cảm ơn bạn đã gia nhập cộng đồng MarryBaby!',
              })}
              desc={f({
                id: 'askDoctor.welcome.desc',
                defaultMessage:
                  'Chia sẻ với bác sĩ các thắc mắc của bạn để được giải đáp miễn phí',
              })}
            />
          ) : (
            <NotiScreen
              heading={f({
                id: 'askDoctor.requireLogin.heading',
                defaultMessage:
                  'Vui lòng đăng nhập hoặc đăng ký để tạo câu hỏi',
              })}
              desc={f({
                id: 'askDoctor.requireLogin.desc',
                defaultMessage:
                  'Cho MarryBaby biết suy nghĩ của bạn về bài viết này nhé!',
              })}
              btnLabel={f({
                id: 'askDoctor.requireLogin.btn',
                defaultMessage: 'Đăng ký thành viên MarryBaby',
              })}
              onBtnClick={handleRedirectSSO}
            />
          )}
        </StyledListWrapper>
      </Section>
      {showPostForm && (
        <PostForm
          onPostCreatedEdited={(post: Post, isEdit: boolean) => {
            setShowPostForm(false)
            setEditPostData()
            handleCreateEditPost?.({
              ...post,
              id: String(post?.id),
            })
            !isEdit && setPostCount((v: number) => v + 1)
          }}
        />
      )}
      {showPostDetailPopup && (
        <PostDetail
          onDeletePost={() => {
            refetch?.()
            setShowPostDetailPopup(false)
            setSelectedPost()
            setPostCount((v: number) => v - 1)
          }}
          handleCreateEditPost={handleCreateEditPost}
        />
      )}
    </>
  )
}

export { MainBody }
